import { render, staticRenderFns } from "./TemplateTroubleDescribleTags.vue?vue&type=template&id=2126f246&"
import script from "./TemplateTroubleDescribleTags.vue?vue&type=script&lang=ts&"
export * from "./TemplateTroubleDescribleTags.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports